import { ReactNode, useId } from 'react';
import CustomTable from '@shared/components/CustomTable/CustomTable';
import type { CustomTableProps } from '@shared/components/CustomTable/CustomTableProps';
import dashboardStyles from '@shared/components/Dashboard/Dashboard.module.scss';
import styles from './DataTablePanel.module.scss';

export interface DataTablePanelProps<T> extends Omit<CustomTableProps<T>, 'variant' | 'buttons'> {
  sectionTitle: string;
  description?: ReactNode;
  totalLabel?: ReactNode;
  errorMessage?: ReactNode;
}

/** The complete table presentation shared by Callback requests and other list pages. */
const DataTablePanel = <T,>({
  sectionTitle,
  description,
  totalLabel,
  errorMessage,
  simplePagination = false,
  ...tableProps
}: DataTablePanelProps<T>) => {
  const titleId = `table-panel-${useId().replace(/:/g, '')}`;

  return (
    <section className={`${dashboardStyles.card} ${styles.panel}`} aria-labelledby={titleId}>
      <div id={titleId} className={`${dashboardStyles.sectionTitle} ${dashboardStyles.mb2}`}>
        {sectionTitle}
      </div>
      {description ? <div style={{ marginBottom: 16, opacity: 0.8 }}>{description}</div> : null}
      {errorMessage ? <div role="alert" className={styles.error}>{errorMessage}</div> : null}
      {totalLabel != null ? (
        <div aria-live="polite" style={{ marginBottom: 16, opacity: 0.8 }}>{totalLabel}</div>
      ) : null}
      <CustomTable<T> {...tableProps} simplePagination={simplePagination} variant="callbackRequests" />
    </section>
  );
};

export default DataTablePanel;
